<app-header [isPublic]="true"></app-header>
<div class="container-fluid content">
</div>
<footer class="footer">
  <app-footer></app-footer>
</footer>
